<template>
  <div v-if="isValid">
    <v-list-tile class="v-list--two-line">
      <v-list-tile-avatar>
        <v-icon>{{icon}}</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>
          <span class="title">
            {{ title }}
          </span>
        </v-list-tile-title>
        <v-list-tile-sub-title>
          {{ description }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-btn @click="openLinkInNewTab" small>
          <v-icon left>link</v-icon>
          Visit
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
    <v-divider v-if="!isLast" />
  </div>
</template>
<script>
  export default {
    props: {
      value: {
        type: Object,
        required: true,
      },
      isFirst: {
        type: Boolean,
        default: false,
      },
      isLast: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      itemData() {
        return JSON.parse(this.value.ItemData)
      },
      title() {
        return this.itemData.title
      },
      description() {
        return this.itemData.description
      },
      url() {
        return this.itemData.url || ''
      },
      icon() {
        return this.itemData.icon || 'bookmark_border'
      },
      isValid() {
        return this.itemData != null &&
          this.itemData.title != null &&
          this.itemData.url != null
      },
      urlWithHttp() {
        if (!this.url.startsWith('http')) {
          return `http://${this.url}`
        }
        return this.url
      },
    },
    methods: {
      openLinkInNewTab() {
        window.open(this.urlWithHttp, '_blank')
      },
    },
  }
</script>